module.exports = "<prg-select-device [source]=\"devices | async\" (selected)=\"sensorSelected($event)\"></prg-select-device>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-sensors/select-sensor/select-sensor.component.html
// module id = 1601
// module chunks = 2